module.exports = __webpack_public_path__ + "img/icon_coupon2.9c79c701.svg";